import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9141c402"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_3 = { class: "bg-green-200 p-3 rounded-l-lg rounded-br-lg max-w-lg shadow-sm mb-2" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  key: 1,
  class: "flex justify-start"
}
const _hoisted_6 = { class: "bg-slate-50 p-3 rounded-r-lg rounded-bl-lg max-w-lg shadow-sm mb-2" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  key: 0,
  class: "flex justify-start py-8 p-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative flex h-3 w-9" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75" }),
  /*#__PURE__*/_createElementVNode("span", { class: "relative inline-flex rounded-full h-3 w-9 bg-indigo-500" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "bg-gray-100 p-4 border-t border-gray-200 flex items-center space-x-4 fixed bottom-0 w-full max-w-7xl mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" Chat Window "),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['message', message.sender])
      }, [
        (message.sender === 'user')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(message.text), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(message.text), 1)
              ])
            ]))
      ], 2))
    }), 128)),
    (_ctx.isWaitingResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
        placeholder: "Mesajınız...",
        class: "flex-grow p-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500",
        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.message]
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
        class: "bg-gray-900 text-white px-6 py-3 rounded-full shadow-md hover:bg-blue-600"
      }, " Gönder ")
    ])
  ]))
}